import React from 'react'
import PropTypes from 'prop-types'
import qs from 'query-string'

import Mobile from './HOC/Mobile'
import Analytics from './HOC/Analytics'
import Title from './HOC/Title'
import ChangePassword from '../components/ChangePassword'

function ChangePasswordContainer({ location }) {
  return <ChangePassword search={qs.parse(location.search)} />
}

ChangePasswordContainer.propTypes = {
  location: PropTypes.object,
}

export default Title(Analytics(Mobile(ChangePasswordContainer)), 'Recuperar senha – Hi Platform')



// WEBPACK FOOTER //
// ./src/containers/ChangePassword.js